var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mx-n2 mt-n1",attrs:{"no-body":""}},[_c('OpsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }